<template>
<div class="chapter">
<div class="inner_page">
<div id="wrapper" style="background-color:rgb(255,255,255);">
<div class="left" id="main"><div class="selectionFrame" id="frame2" style="left: 0px; top: 0px; z-index: 1002;" xmlns="http://www.w3.org/1999/xhtml"><img alt="" class="item" id="item2" src="CI_C49FCA46-BF2B-4A23-AFE5-802EA1A0742C.jpg" style="width: 900px; height: 675px;"/></div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page002.vue?727522be